(() => {
  if (window.productLocalStockControlsInitialized) return;

  window.productLocalStockControlsInitialized = true;

  const variantSelector =
    'input[type="radio"][data-variantid]';

  function getProductForm(selectedRadio, productContainer) {
    if (selectedRadio.form) {
      return selectedRadio.form;
    }

    const formId = selectedRadio.getAttribute('form');

    if (formId) {
      return document.getElementById(formId);
    }

    return productContainer?.querySelector(
      'form[data-type="add-to-cart-form"]'
    );
  }

  function setSubmitLabel(submitButton, label) {
    if (submitButton.matches('input')) {
      submitButton.value = label;
      return;
    }

    const labelElement = submitButton.querySelector('span');

    if (labelElement) {
      labelElement.textContent = label;
    } else {
      submitButton.textContent = label;
    }
  }

  function updateSelectedVariant(selectedRadio) {
    if (!selectedRadio?.checked) return;

    const productContainer =
      selectedRadio.closest('[id^="MainProduct-"]') ||
      selectedRadio.closest(
        '.shopify-section, product-info, .product'
      ) ||
      document;

    const productForm = getProductForm(
      selectedRadio,
      productContainer
    );

    const idInput = productForm?.querySelector(
      'input[name="id"]'
    );

    const submitButton = productForm?.querySelector(
      '.product-form__submit[type="submit"]'
    );

    const skuElement =
      productContainer.querySelector('.product__sku') ||
      document.querySelector('.product__sku');

    // Update the product form's selected variant.
    if (idInput) {
      idInput.value = selectedRadio.dataset.variantid;

      idInput.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    }

    // Update the displayed SKU.
    if (skuElement) {
      skuElement.textContent =
        `SKU: ${selectedRadio.dataset.sku || ''}`;
    }

    if (!submitButton) return;

    const allVariantsOutOfStock =
      submitButton.dataset.allVariantsOutOfStock === 'true';

    const selectedVariantIsDisabled =
      selectedRadio.classList.contains('disabled');

    const isDisabled =
      allVariantsOutOfStock ||
      selectedVariantIsDisabled;

    submitButton.disabled = isDisabled;

    submitButton.setAttribute(
      'aria-disabled',
      String(isDisabled)
    );

    submitButton.classList.toggle(
      'disabled',
      isDisabled
    );

    setSubmitLabel(
      submitButton,
      allVariantsOutOfStock
        ? 'Out of Stock'
        : 'Add to cart'
    );
  }

  function initializeCheckedVariants(root = document) {
    root
      .querySelectorAll(`${variantSelector}:checked`)
      .forEach(updateSelectedVariant);
  }

  // Update when a variant radio is selected.
  document.addEventListener('change', (event) => {
    if (event.target.matches(variantSelector)) {
      updateSelectedVariant(event.target);
    }
  });

  // Initialize the currently selected variant.
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeCheckedVariants()
    );
  } else {
    initializeCheckedVariants();
  }

  // Reinitialize when Shopify reloads the section editor.
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeCheckedVariants(event.target);
    }
  );
})();